/**
 * harvestEvent Normalizr Schema
 */

import { schema } from 'normalizr';

import pickType from './pickType';

const harvestEvent = new schema.Entity('harvestEvents', { pickType });

export default harvestEvent;
